import { render, staticRenderFns } from "./DisputesTable.view.vue?vue&type=template&id=7658556e&"
import script from "./DisputesTable.view.vue?vue&type=script&lang=js&"
export * from "./DisputesTable.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7658556e')) {
      api.createRecord('7658556e', component.options)
    } else {
      api.reload('7658556e', component.options)
    }
    module.hot.accept("./DisputesTable.view.vue?vue&type=template&id=7658556e&", function () {
      api.rerender('7658556e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/rearchitected/themes/atmo/views/pages/purchases/item/view/partials/common/DisputesTable.view.vue"
export default component.exports